import { LogOut01, User01 } from "@untitledui/icons";
import { Button as AriaButton } from "react-aria-components";
import { Avatar } from "@/components/base/avatar/avatar";
import { AvatarLabelGroup } from "@/components/base/avatar/avatar-label-group";
import { getInitials } from "@/components/base/avatar/utils";
import { Dropdown } from "@/components/base/dropdown/dropdown";
import { cx } from "@/utils/cx";

type AvatarSize = "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

export type AvatarDropdownProps = {
	name: string;
	email: string;
	avatarSrc?: string | null;
	onSignOut: () => void;
	onUserProfile: () => void;
	size?: AvatarSize;
};

export const AvatarDropdown: React.FC<AvatarDropdownProps> = ({
	name,
	email,
	avatarSrc,
	onSignOut,
	onUserProfile,
	size = "md",
}) => {
	const initials = getInitials(name);

	const labelGroupSize = (() => {
		if (size === "xxs" || size === "xs") return "sm";
		if (size === "2xl") return "xl";
		return size;
	})();

	return (
		<Dropdown.Root>
			<AriaButton
				className={({ isPressed, isFocusVisible }) =>
					cx(
						"group relative inline-flex cursor-pointer rounded-full outline-focus-ring",
						(isPressed || isFocusVisible) && "outline-2 outline-offset-2",
					)
				}
			>
				<Avatar alt={name} src={avatarSrc} initials={initials} size={size} />
			</AriaButton>

			<Dropdown.Popover>
				<div className="flex gap-3 border-b border-secondary p-3">
					<AvatarLabelGroup
						size={labelGroupSize}
						src={avatarSrc}
						title={name}
						subtitle={email}
						initials={initials}
					/>
				</div>
				<Dropdown.Menu>
					<Dropdown.Separator />
					<Dropdown.Section>
						<Dropdown.Item icon={User01} onAction={onUserProfile}>
							User profile
						</Dropdown.Item>
						<Dropdown.Item icon={LogOut01} onAction={onSignOut}>
							Sign out
						</Dropdown.Item>
					</Dropdown.Section>
				</Dropdown.Menu>
			</Dropdown.Popover>
		</Dropdown.Root>
	);
};

export default AvatarDropdown;
